import React from 'react'
import { FormattedHTMLMessage, NavMenuItem, AppSvg, newIcons } from '@web/walter-ui-kit'

import { lang } from '../lang'
import ProTradeButton from '../buttons/ProTradeButton'
import styles from './style.module.css'
import { Routes } from '~constants/routes'
import { useCommonCMSConfig, useGetThreeDSChallengesData } from '~api'
import Logo from '~components/App/Layout/Logo'
import useSelectedTabs from '~hooks/useSelectedTabs'
import { useMenuStore } from '~store/menu'

// eslint-disable-next-line max-lines-per-function
function SideMenu() {
    const { features = {} } = useCommonCMSConfig().data ?? {}
    const { showSwapPage, showStaking, hideMarketPage, showCards } = features
    const tabs = useSelectedTabs()
    const {
        data: { onCardClick },
    } = useMenuStore()

    const { data } = useGetThreeDSChallengesData()

    return (
        <div className={styles.sidePanel}>
            <div className={styles.logo}>
                <Logo />
            </div>

            <nav className={styles.menu} data-pointer="navigation_menu">
                <NavMenuItem
                    icon={<AppSvg path="new-icons" size={24} svgName={newIcons.ic24Home} />}
                    type="navLink"
                    to={Routes.wallet}
                    selected={tabs[Routes.wallet]}
                    dataPointer="wallet"
                >
                    <FormattedHTMLMessage {...lang.wallet} />
                </NavMenuItem>

                {!hideMarketPage && (
                    <NavMenuItem
                        icon={<AppSvg path="new-icons" size={24} svgName={newIcons.ic24SearchOutline} />}
                        type="navLink"
                        to={Routes.market}
                        selected={tabs[Routes.market]}
                        dataPointer="market"
                    >
                        <FormattedHTMLMessage {...lang.market} />
                    </NavMenuItem>
                )}
                {showCards && (
                    <div onClick={onCardClick}>
                        <NavMenuItem
                            icon={<AppSvg path="new-icons" size={24} svgName={newIcons.ic24Card} />}
                            type="navLink"
                            to={Routes.cards}
                            selected={tabs[Routes.cards]}
                            dataPointer="cards"
                            after={
                                (data?.challenges || [])?.length > 0 && (
                                    <AppSvg
                                        svgName={newIcons.ic24Info}
                                        size={24}
                                        path="new-icons"
                                        className={styles.alert}
                                    />
                                )
                            }
                        >
                            <FormattedHTMLMessage {...lang.cards} />
                        </NavMenuItem>
                    </div>
                )}
                <NavMenuItem
                    icon={<AppSvg path="new-icons" size={24} svgName={newIcons.ic24History} />}
                    type="navLink"
                    to={Routes.history}
                    selected={tabs[Routes.history]}
                    dataPointer="history"
                >
                    <FormattedHTMLMessage {...lang.history} />
                </NavMenuItem>
                {showSwapPage && (
                    <NavMenuItem
                        icon={<AppSvg path="new-icons" size={24} svgName={newIcons.ic24Swap} />}
                        type="navLink"
                        to={Routes.swap}
                        selected={tabs[Routes.swap]}
                        dataPointer="swap"
                    >
                        <FormattedHTMLMessage {...lang.swap} />
                    </NavMenuItem>
                )}
                {showStaking && (
                    <NavMenuItem
                        icon={<AppSvg path="new-icons" size={24} svgName={newIcons.ic24Percent} />}
                        type="navLink"
                        to={Routes.staking}
                        selected={tabs[Routes.staking]}
                        dataPointer="staking"
                    >
                        <FormattedHTMLMessage {...lang.staking} />
                    </NavMenuItem>
                )}
            </nav>

            <div className={styles.profile}>
                <ProTradeButton />
            </div>
        </div>
    )
}

export default SideMenu
